import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  isAuditModalOpen: boolean;
  isRequestCallModalOpen: boolean;
  openAuditModal: () => void;
  closeAuditModal: () => void;
  openRequestCallModal: () => void;
  closeRequestCallModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAuditModalOpen, setIsAuditModalOpen] = useState(false);
  const [isRequestCallModalOpen, setIsRequestCallModalOpen] = useState(false);

  const openAuditModal = () => setIsAuditModalOpen(true);
  const closeAuditModal = () => setIsAuditModalOpen(false);
  const openRequestCallModal = () => setIsRequestCallModalOpen(true);
  const closeRequestCallModal = () => setIsRequestCallModalOpen(false);

  return (
    <ModalContext.Provider value={{
      isAuditModalOpen,
      openAuditModal,
      closeAuditModal,
      isRequestCallModalOpen,
      openRequestCallModal,
      closeRequestCallModal
    }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
